import { Button, Size, Spinner, Tier } from '@drawbotics/react-drylus';
import { useAppContext } from '@tokamakjs/react';
import queryString from 'query-string';
import { Fragment } from 'react';

import { translate as t } from '~/utils';

import { AppContext } from '../../types';
import { MicrosoftIcon } from './MicrosoftIcon';

export enum AuthFlow {
  SIGN_IN = 'SIGN_IN',
  SIGN_UP = 'SIGN_UP',
}

interface MicrosoftSSOProps {
  isLoading: boolean;
  onSuccess: (microsoftCode: string) => void;
  locationSearch: string;
  flow: AuthFlow;
  isInvitation?: boolean;
}

export const MicrosoftSSO = ({
  isLoading,
  locationSearch,
  flow,
  onSuccess,
  isInvitation,
}: MicrosoftSSOProps) => {
  const appContext = useAppContext<AppContext>();
  const isLoginFlow = flow === AuthFlow.SIGN_IN;
  const microsoftAuthUrl =
    'https://login.microsoftonline.com' +
    '/common/oauth2/v2.0/authorize?' +
    `client_id=${appContext.env.AZURE_CLIENT_ID}` +
    '&response_type=code' +
    '&prompt=select_account' +
    `&redirect_uri=${encodeURIComponent(
      `${window.location.origin}/auth/${isLoginFlow ? 'login' : 'sign-up'}`,
    )}` +
    '&scope=offline_access openid email profile User.Read Calendars.ReadWrite' +
    '&response_mode=fragment' +
    (isLoginFlow ? '' : `&state=${locationSearch}`);

  const buttonText = isLoginFlow
    ? t('routes.login.sign_in_with_microsoft')
    : isInvitation
    ? t('join_with_microsoft')
    : t('routes.sign_up.sign_up_with_microsoft');

  const handleMicrosoftSignIn = () => {
    const signInWindow = window.open(microsoftAuthUrl, '', 'width=550,height=650');

    const intervalId = setInterval(() => {
      try {
        if (signInWindow != null) {
          const { code: microsoftCode } = queryString.parse(signInWindow.location.hash);

          if (microsoftCode != null && typeof microsoftCode === 'string') {
            clearInterval(intervalId);

            onSuccess(microsoftCode);

            signInWindow.close();
          }
        }
      } catch (error) {
        return;
      }
    }, 500);
  };

  return (
    <Fragment>
      <Button
        leading={<MicrosoftIcon />}
        disabled={isLoading}
        trailing={isLoading ? <Spinner /> : null}
        tier={Tier.SECONDARY}
        size={Size.LARGE}
        onClick={handleMicrosoftSignIn}
        fullWidth>
        {buttonText}
      </Button>
    </Fragment>
  );
};
